(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection_selector"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    
    var MAX_SELECTIONS = 2;
    var swiperInstances = [];

    function getSelectedButtons() {
      return Array.from(
        document.querySelectorAll(
          '[data-collection-product-selector] .custom-collection-products-item--selected'
        )
      );
    }

    function updateRossieSelectedSwatch() {
      var modal = document.querySelector('#rossi-order-swatches-modal');
      if (!modal) return;

      var selectedButtons = getSelectedButtons();
      var swatchItems = modal.querySelectorAll(
        '.rossie-modal-selected-swatch__item'
      );

      swatchItems.forEach(function (item, index) {
        var image = item.querySelector('.rossie-modal-selected-swatch__image img');
        var name = item.querySelector('.rossie-modal-selected-swatch__name');
        var selectedButton = selectedButtons[index];

        if (selectedButton) {
          var title = selectedButton.getAttribute('data-cps-product-title');
          var imageUrl = selectedButton.getAttribute('data-cps-product-image');

          if (image) {
            image.src = imageUrl || '';
            image.alt = title || '';
          }

          if (name) {
            name.textContent = title || '';
          }

          item.style.display = '';
        } else {
          if (image) {
            image.src = '';
            image.alt = '';
          }

          if (name) {
            name.textContent = '';
          }

          item.style.display = 'none';
        }
      });
    }

    function updateSelectedNames(block) {
      var selectedButtons = block.querySelectorAll(
        '.custom-collection-products-item--selected'
      );

      var names = Array.from(selectedButtons).map(function (button) {
        return button.getAttribute('data-cps-product-title') || '';
      });

      var selectedName = block.querySelector(
        '.custom-collection-selector-block__selected-name'
      );

      if (selectedName) {
        selectedName.textContent = names.join(', ');
      }

      var selectedSwatchesInput = document.querySelector(
        '#rossi-selected-swatches'
      );

      if (selectedSwatchesInput) {
        selectedSwatchesInput.value = names.join(', ');
      }
    }

    function initProductSwipers() {
      if (typeof Swiper === 'undefined') {
        console.error('[collection-selector] Swiper library not loaded');
        return;
      }

      document.querySelectorAll('.custom-collection-products-list').forEach(function (list) {
        if (list.swiper) return;

        var swiper = new Swiper(list, {
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween:'5px', 
          watchOverflow: true,
          
          grid: {
            rows: 2,
            fill: 'row'
          },
          
          pagination: {
            el: list.querySelector('.swiper-pagination'),
            clickable: true,
            dynamicBullets: false
          },
          
          navigation: {
            nextEl: list.querySelector('.swiper-button-next'),
            prevEl: list.querySelector('.swiper-button-prev')
          },
          
          breakpoints: {
            0: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              grid: { rows: 2, fill: 'row' }
            },
            480: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              grid: { rows: 2, fill: 'row' }
            },
            768: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              grid: { rows: 2, fill: 'row' }
            }
          }
        });

        swiperInstances.push(swiper);
      });
    }

    function loadSwiperAndInit() {
      if (typeof Swiper !== 'undefined') {
        initProductSwipers();
        return;
      }

      var attempts = 0;
      var maxAttempts = 100; // ~10 seconds at 100ms intervals
      var pollId = setInterval(function () {
        attempts++;

        if (typeof Swiper !== 'undefined') {
          clearInterval(pollId);
          initProductSwipers();
          return;
        }

        if (attempts >= maxAttempts) {
          clearInterval(pollId);
          console.error(
            '[collection-selector] Swiper failed to load from CDN. ' +
            'Check your internet connection and that Swiper CDN is accessible.'
          );
        }
      }, 100);
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.custom-collection-products-item');
      if (!button) return;

      var block = button.closest('[data-collection-product-selector]');
      if (!block) return;

      var isSelected = button.classList.contains('custom-collection-products-item--selected');
      var selectedButtons = block.querySelectorAll('.custom-collection-products-item--selected');

      if (isSelected) {
        button.classList.remove('custom-collection-products-item--selected');
        updateSelectedNames(block);
        updateRossieSelectedSwatch();
        return;
      }

      if (selectedButtons.length >= MAX_SELECTIONS) {
        return;
      }

      button.classList.add('custom-collection-products-item--selected');
      updateSelectedNames(block);
      updateRossieSelectedSwatch();
    });

    document.addEventListener('DOMContentLoaded', function () {
      loadSwiperAndInit();
      updateRossieSelectedSwatch();

      document.querySelectorAll('[data-collection-product-selector]').forEach(function (block) {
        updateSelectedNames(block);
      });
    });

  })();
  } catch(e) { console.error(e); }
})();

})();
